export default __webpack_public_path__ + "static/media/Group 1854.82be9dbe.png";